module.exports = __webpack_public_path__ + "5c4a70ba9b36c4860f543a997c927239.svg";